import { Bot } from 'lucide-react';

export const AgentsLogo = ({ height = 26 }: { height?: number }) => {
  return <Bot height={height} width={height} />;
};
